export default __webpack_public_path__ + "static/media/kaikan_logo.35e335e1.svg";